import { Box } from '@material-ui/core'
import React, { useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import { ColorBaseWhite } from 'assets/styles/variables'
import { FontWeightRegular } from 'assets/styles/variables'
import { ColorBaseRichBlack } from 'assets/styles/variables'
import i18n from 'common/util/internationalization'
import { TOAST_DURATION } from 'common/constants/constants'
import { AddActionEditActionButton } from 'components/shared/StyledComponents'
import SuccessIcon from 'assets/icons/SuccessIcon'
import ToastErrorIcon from 'assets/icons/ToastErrorIcon'

const useStyles = makeStyles(() => ({
    successToast: {
        position: 'fixed',
        gap: '16px',
        borderRadius: '2px',
        top: '4%',
        right: '2%',
        background: ColorBaseWhite,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        borderLeft: `6px solid #05704b`,
        padding: '4px 8px 4px 16px',
        height: '50px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        minWidth: '334px'
    },
    failToast: {
        position: 'fixed',
        gap: '16px',
        borderRadius: '2px',
        top: '2%',
        right: '2%',
        background: ColorBaseWhite,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        borderLeft: `6px solid #AF292E`,
        padding: '10px 8px 10px 16px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        minWidth: '334px'
    },
    toastMessageSuccess: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: FontWeightRegular,
        lineHeight: '20px',
        color: ColorBaseRichBlack
    },
    toastMessageError: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: FontWeightRegular,
        lineHeight: '20px',
        color: ColorBaseRichBlack,
        maxWidth: '185px'
    }
}))

export const ToastNotification = ({
    message,
    showToast,
    setShowToast,
    toastType,
    duration = TOAST_DURATION
}: {
    message: string
    showToast: boolean
    setShowToast: (value: boolean) => void
    toastType: string
    duration?: number
}) => {
    const classes = useStyles()
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        if (showToast) {
            // Clear any existing timer first
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }

            timerRef.current = setTimeout(() => {
                setShowToast(false)
            }, duration)
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
        }
    }, [showToast, setShowToast, duration])

    if (!showToast) return null

    return (
            <Box
                className={toastType === 'success' ? classes.successToast : classes.failToast}
                role="alert"
                aria-live="assertive"
                aria-atomic="true">
                {toastType === 'success' ? <SuccessIcon /> : <ToastErrorIcon />}
                <Box
                    aria-label={i18n.t('TOAST_MESSAGE')}
                    className={
                        toastType === 'success'
                            ? classes.toastMessageSuccess
                            : classes.toastMessageError
                    }>
                    {message}
                </Box>
                <AddActionEditActionButton
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    aria-pressed={showToast ? 'true' : 'false'}
                    onClick={() => setShowToast(false)}
                    aria-label={i18n.t('TOAST_DISMISS_BUTTON')}
                    style={{ marginLeft: toastType === 'success' ? '50px' : '0px' }}>
                    {i18n.t('TOAST_DISMISS_BUTTON')}
                </AddActionEditActionButton>
            </Box>
    )
}
